import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

// Badge met een toon: tekstkleur + zachte achtergrond (statussen, prioriteiten, labels).
const badgeVariants = cva("inline-flex min-h-[22px] items-center gap-[5px] whitespace-nowrap rounded-full px-2 py-[3px] text-[11px] font-bold", {
  variants: {
    tone: {
      neutral: "bg-surface-warm text-navy-700",
      green: "bg-tone-green-soft text-tone-green",
      teal: "bg-tone-teal-soft text-tone-teal",
      yellow: "bg-tone-yellow-soft text-tone-yellow",
      blue: "bg-tone-blue-soft text-tone-blue",
      purple: "bg-tone-purple-soft text-tone-purple",
      red: "bg-tone-red-soft text-tone-red",
      blush: "bg-blush-soft text-blush-ink"
    }
  },
  defaultVariants: { tone: "neutral" }
});

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, tone, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ tone }), className)} {...props} />;
}

export { Badge, badgeVariants };
